import { createFileRoute } from '@tanstack/react-router'

import { InboxesPage } from '#/modules/communication/inboxes-page'
import { validateListSearch } from '#/shared/lib/list-search'

export const Route = createFileRoute('/_shell/inboxes')({
  component: InboxesPage,
  validateSearch: validateListSearch,
})
